import React from "react";
import DinnerInfo from "./info/DinnerInfo";

export const dinnerSidebarSections = [
  { id: 1, title: "dane produktu", component: <DinnerInfo /> },
];
